<template>
  <div style="padding: 15px">
    <div style="margin-bottom: 20px;">
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        highlight-current-row
        highlight-hover-row
        row-id="id"
        height="500"
        :loading="loading"
        :data="tableData"
      >
        <vxe-table-column
          field="orderDetailNumber"
          title="订单编号"
          min-width="300"
        />
        <vxe-table-column field="coalTypeName" title="货物" min-width="200" />
        <vxe-table-column
          field="shipperAddress"
          title="出发地"
          min-width="300"
        />
        <vxe-table-column
          field="consigneeAddress"
          title="目的地"
          min-width="300"
        />
        <vxe-table-column field="speedGrade" title="配送速度" min-width="100" />
        <vxe-table-column
          field="serviceGrade"
          title="服务态度"
          min-width="100"
        />
        <vxe-table-column
          field="safetyGrade"
          title="运输安全"
          min-width="100"
        />
        <vxe-table-column
          field="lossGrade"
          title="货物损耗度"
          min-width="100"
        />
        <vxe-table-column
          field="satisfactionGrade"
          title="综合满意度"
          min-width="100"
        />
        <vxe-table-column
          v-if="form.driverCode"
          field="shipperName"
          title="托运人"
          min-width="300"
        />
        <vxe-table-column
          v-if="form.userCode"
          field="driverName"
          title="实际承运人"
          min-width="300"
        />
        <vxe-table-column field="gmtCreated" title="评论时间" min-width="200" />
      </vxe-table>
      <vxe-pager
        :loading="loading"
        :current-page.sync="form.pageNum"
        :page-sizes="Pagingconf"
        :page-size.sync="form.pageSize"
        :total="form.total"
        :layouts="[
          'PrevJump',
          'PrevPage',
          'Number',
          'NextPage',
          'NextJump',
          'Sizes',
          'FullJump',
          'Total'
        ]"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>
<script>
import { evaluateList } from "@/api/CustomerService";
export default {
  name: "Detail",
  data() {
    return {
      loading: false,
      tableData: [],
      form: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        driverCode: "",
        userCode: "",
        commentType: 0
      },
      Pagingconf: []
    };
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      this.tableData = [];
      this.form.driverCode = code;
      this.form.commentType = 0;
      evaluateList(this.form).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.form.total = response.data.total;
      });
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.form.pageNum = currentPage;
      this.form.pageSize = pageSize;
      this.getInfo();
    }
  }
};
</script>
